import { render } from "./UpdateRewardSidebar.vue?vue&type=template&id=c27357ce"
import script from "./UpdateRewardSidebar.vue?vue&type=script&lang=js"
export * from "./UpdateRewardSidebar.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__